import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SectionA from './Components/SectionA';
import Pricing from './Components/Pricing';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"
import sessionstorage from "sessionstorage";
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux-store';
import HowItWorks from './Components/HowItWorks/HowItWorks';
import Footer from '../../GlobalComp/Footer/Footer';
import KeyFeatures from './Components/KeyFeatures/KeyFeatures';
import Faq from './Components/Faq/Faq';

function Home() {

  const navigateTo = useNavigate();

  const scrollToElement = (elementId) => {
    const targetElement = document.getElementById(elementId);

    if (targetElement) {
      const offset = 0;
      const targetPosition = targetElement.offsetTop + offset;

      window.scroll({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  };
  const location = useLocation();

  useEffect(() => {
    const scrollInfo = location?.state?.scrollTo;
    if (scrollInfo) {
      setTimeout(() => {
        scrollToElement(scrollInfo.id, scrollInfo.offset);

        navigateTo(location.pathname, { replace: true, state: {} });
      }, 100);
    }
  }, [location.state]);

  return (
    <div>
      <SectionA />
      <HowItWorks />
      <KeyFeatures />
      <Pricing />
      <Faq />
      <Footer />
    </div>
  );
}

export default Home;
